// Models
import { BaseODataEntity } from "./BaseODataEntity";
// Utilities
import { getDiff, getDiffTemporalAndArrayCustomizer, applyDiffTemporalAndArrayCustomizer } from "@ms/uno-utilities/lib/local/ObjectUtilities";
import mergeWith from "lodash/mergeWith";
/**
 * Base class for patchable planner odata entities.
 * This class provides a common structure for entities that can be patched.
 */ export class DiffableClonableODataEntity extends BaseODataEntity {
    getDiff(target) {
        return getDiff(this, target, getDiffTemporalAndArrayCustomizer, true);
    }
    applyDiffs(...diff) {
        if (diff.length > 0) {
            return mergeWith(this.getClone(), ...diff, applyDiffTemporalAndArrayCustomizer);
        }
        return this;
    }
    constructor(propertyBag){
        super(propertyBag);
    }
}
